export const ACTIVITY_ACTION_TYPES = {
	ACTIVITY_SET_NOTE: 'ACTIVITY_SET_NOTE',
	ACTIVITY_SET_PROGRESS: 'ACTIVITY_SET_PROGRESS'
};

export const activitySetNote = (note) => {
	return {
		type: ACTIVITY_ACTION_TYPES.ACTIVITY_SET_NOTE,
		payload: { note }
	};
};

export const activitySetProgress = (progressData) => {
	return {
		type: ACTIVITY_ACTION_TYPES.ACTIVITY_SET_PROGRESS,
		payload: { progressData }
	};
};

export default (state, action) => {
	const { type, payload } = action;
	switch (type) {
		case ACTIVITY_ACTION_TYPES.ACTIVITY_SET_NOTE: {
			const { note } = payload;

			const { projectActivities, projectActivitiesMap } = state;
			const projectActivitiesCopy = [...projectActivities];
			const activity = projectActivitiesCopy[projectActivitiesMap[note.activityId]];
			const notes = activity.notes;

			let foundNote = false;
			for (const i in notes) {
				// When offline, a new note is assigned a temp id. When syncing to the server it receives an new id. Set the temp note object's id to the server-provided one.
				if (note.tempId && notes[i].noteId === note.tempId) notes[i].noteId = note.noteId;

				if (notes[i].noteId === note.noteId) {
					notes[i].note = note.note;
					foundNote = true;
					break;
				}
			}

			// If it wasn't found, add it (it's a new note)
			if (!foundNote) {
				notes.push(note);
			}

			activity.hasChanged = true;

			return {
				...state,
				projectActivities: projectActivitiesCopy
			};
		}
		case ACTIVITY_ACTION_TYPES.ACTIVITY_SET_PROGRESS: {
			const { progressData } = payload;
			const { activityId } = progressData;

			const { projectActivities, projectActivitiesMap } = state;
			const projectActivitiesCopy = [...projectActivities];
			const activityCopy = projectActivitiesCopy[projectActivitiesMap[activityId]];

			activityCopy.statusCode = progressData.statusCode;
			activityCopy.start = progressData.start;
			activityCopy.finish = progressData.finish;
			activityCopy.actualStart = progressData.actualStart;
			activityCopy.actualFinish = progressData.actualFinish;
			activityCopy.targetStart = progressData.targetStart;
			activityCopy.targetFinish = progressData.targetFinish;
			activityCopy.earlyFinish = progressData.earlyFinish;
			activityCopy.expectFinish = progressData.expectFinish;
			activityCopy.remainingDuration = parseFloat(progressData.remainingDuration);
			activityCopy.targetDuration = parseFloat(progressData.targetDuration);
			activityCopy.percentComplete = parseFloat(progressData.percentComplete);

			// Update resources
			activityCopy.resourceDetails = activityCopy.resourceDetails.map(resource => {
				resource.Actual = (activityCopy.percentComplete * resource.Budgeted) / 100;
				resource.Remaining = resource.Budgeted - resource.Actual;
				return resource;
			});

			activityCopy.hasChanged = true;

			return {
				...state,
				projectActivities: projectActivitiesCopy
			};
		}
		default:
			console.log('action type not found: ', type);
			return state;
	}
};
